<template>
  <!-- 手机版菜单 -->
  <div class="menu" v-if="showCollapse" @click="handleClick">
    <el-collapse v-model="activeName" accordion class="menu-collapse">
      <el-collapse-item
        :title="item.menuItem"
        :name="index - 1"
        v-for="(item, index) in menuList"
        :key="index"
        :disabled="!item.children"
        @click.native="handleProductClick(item.path)"
      >
        <template slot="title">
          {{ item.menuItem }}
          <img
            v-if="item.menuItem === '解决方案' || item.menuItem === '产品介绍'"
            src="./new.png"
            alt=""
            style="width: 32px; margin-left: 4px; position: relative; top: -8px"
          />
        </template>

        <div class="solve-programme-menu">
          <div v-if="item.path == 'product'" class="product-menu-list">
            <div
              v-for="product in item.children"
              :key="product.name"
              class="product-menu-item"
              @click="handleProductClick(product.path)"
            >
              {{ product.name }}
            </div>
          </div>

          <template v-if="item.path == 'solution'">
            <div
              v-for="el in item.children"
              :key="el.title"
              class="hj-workbench-item mb16"
              :index="item.index"
            >
              <div class="item-head mb12">
                {{ el.category }}
              </div>
              <div class="item-content">
                <span
                  v-for="sort in el.items"
                  :key="sort.name"
                  class="programmes"
                  @click="handleProductClick(sort.path)"
                >
                  <span class="txt">
                    {{ sort.name }}
                    <img
                      v-if="sort.new"
                      src="./new.png"
                      alt=""
                      class="new-icon"
                    />
                  </span>
                </span>
              </div>
            </div>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: -2
    }
  },
  computed: {
    showCollapse() {
      return this.$store.state.menuVisible
    },
    menuList() {
      return this.$store.state.menuList
    }
  },
  methods: {
    handleClick(event) {
      const collapse = document.querySelector('.el-collapse')

      if (!collapse.contains(event.target)) {
        this.$store.commit('showMenu', false)
      }
    },
    handleProductClick(pathName) {
      if (pathName !== 'product' && pathName !== 'solution') {
        this.activeName = '-2'
        this.$store.commit('showMenu', false)
        this.$router.push({
          name: pathName
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.menu {
  position: fixed;
  top: 50px;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2001;
  overflow: auto;
  left: 0;
  right: 0;
  .el-collapse-item {
    ::v-deep .el-collapse-item__header {
      padding: 0 0 0 16px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;

      &.is-active {
        font-weight: 600;
      }
    }
    .el-collapse-item__content {
      .solve-programme-menu {
        font-size: 14px;
        padding-left: 16px;
      }

      .solve-programme-menu {
        font-size: 14px;
        .hj-workbench-item {
          .item-head {
            line-height: 12px;
            padding-left: 6px;
            border-left: 2px solid #2d84ff;
            font-weight: 600;
            color: #2d84ff;
          }
          .item-content {
            margin-left: 10px;
            .programmes {
              margin-bottom: 6px;
              cursor: pointer;
              font-weight: 400;
              color: #333333;
              display: inline-flex;
              width: 50%;
              min-width: 140px;

              .txt {
                text-align: justify;
                position: relative;
                word-break: keep-all;
                .new-icon {
                  position: absolute;
                  right: -32px;
                  top: -8px;
                  width: 32px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.product-menu-list {
  display: flex;
  flex-wrap: wrap;
  color: #333;

  .product-menu-item {
    width: 50%;
    padding: 8px 0;
  }
}
</style>
